import { proxy } from 'valtio';
import type { Project } from '~/common/types';

class Store {
  isExpanded: boolean = false;
  civilSearchVersion: 'v1' | 'v2' = 'v1';
  billingTier: Project['billingTier'] = 'draft';
  isProjectInCalifornia: boolean = false; // TODO: Generalize this to support other states

  toggleIsExpanded(val?: boolean) {
    if (val !== undefined) {
      this.isExpanded = val;
    } else {
      this.isExpanded = !this.isExpanded;
    }
  }

  resetIsExpanded() {
    this.isExpanded = false;
  }

  setCivilSearchVersion(version: 'v1' | 'v2') {
    this.civilSearchVersion = version;
  }
}

const projectDetailsStore = proxy(new Store());
export default projectDetailsStore;
